require('./ViewCount.less');
